export enum LocationAction {
    UPDATE_LOCATION = "UPDATE_LOCATION",
    UPDATE_LOADING = "UPDATE_LOADING",
    UPDATE_PERMISSION_DENIED = "UPDATE_PERMISSION_DENIED"
}